import { Typography } from "@mui/material";
import loadingAnimation from "../assets/images/DeadlineLoading.json";
import Lottie from "lottie-react";


const Spinner = ({ loadingText }) => {
  return (
    <>
    <div className="flex justify-center items-center h-[130px]">
      <Lottie 
        animationData={loadingAnimation} 
        loop={true}
        style={{ width: 200 }}
      />
      
    </div>
    <Typography className="text-[var(--dashboardTextPrimary)] mt-4 text-lg">
       {loadingText}
      </Typography>
      </>
  );
};
export default Spinner;